.secondaryAction {
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.6;
}

@media (prefers-reduced-motion: no-preference) {
  .secondaryAction {
    transition: opacity 0.2s;
  }
}

.listItemButton {
  padding: 8px;
  background: transparent;
}

/* Prevent double-hover: the parent ListItem handles the full-width
   hover highlight; the inner button should not add its own. */
.listItemButton.listItemButton:hover {
  background-color: transparent;
}

/* `columns` layout: one dense line. Name, then type and time as fixed columns; time right-aligned. */
.columns {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  min-width: 0;
  min-height: 36px;
  font-family: var(--tuna-typography-fontFamily);
}

.columnsName {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-fontSize-md);
  font-weight: 500;
}

.untitled {
  color: var(--tuna-content-secondary);
  font-style: italic;
  font-weight: 400;
}

.columnsMeta {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-sm);
}

.columnsType {
  width: 88px;
}

.columnsTime {
  min-width: 112px;
  text-align: right;
  white-space: nowrap;
}

/* Phones: type and time drop under the name as one meta line */
@media (max-width: 599.95px) {
  .columns {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .columnsMeta {
    gap: var(--tuna-spacing-1);
  }

  .columnsType,
  .columnsTime {
    width: auto;
    min-width: 0;
    text-align: left;
  }
}

/* Touch screens: the overflow button is a 44px target */
@media (max-width: 899.95px) {
  .columnsAction {
    min-width: 44px;
    min-height: 44px;
  }
}
